import request from '@/plugins/request';

/**
 * 获取Banner轮播图列表
 * @param {Object} params - 请求参数，如页码、尺寸等
 * @returns {Promise} - 返回Promise对象
 */
export function getBannerList(params) {
  return request({
    url: '/fronted/banner/list',
    method: 'get',
    params
  });
}

/**
 * 获取品牌介绍信息
 * @returns {Promise} - 返回Promise对象
 */
export function getBrandIntro() {
  return request({
    url: '/fronted/brand/list',
    method: 'get'
  });
}

/**
 * 获取首页产品列表
 * @param {Object} params - 请求参数，如页码、分类等
 * @returns {Promise} - 返回Promise对象
 */
export function getHomeProducts(params) {
  return request({
    url: '/fronted/products/list',
    method: 'get',
    params
  });
}

/**
 * 获取首页媒体信息列表
 * @param {Object} params - 请求参数，如页码、类型等
 * @returns {Promise} - 返回Promise对象
 */
export function getHomeMedia(params) {
  return request({
    url: '/fronted/media/list',
    method: 'get',
    params
  });
} 
export function getHeaderInfo() {
  return request({
    url: '/fronted/info/getOne',
    method: 'get',
  })
}
export function getFootBase() {
  return request({
    url: '/fronted/footerbase/getOne',
    method: 'get'
  })
}